<template>
  <form @submit.prevent="confirmResetPassword" class="form">
    <p class="form__text">{{ t('auth.new.text') }}</p>
    <ui-input
        :type="'password'"
        :placeholder="t('fields.password')"
        :rules="[isPasswordValid]"
        v-model="password"
    />
    <ui-input
        :type="'password'"
        :placeholder="t('fields.confirmPassword')"
        :rules="[compareStrings]"
        v-model="passwordConfirm"
    />
    <ui-button
        :type="'submit'"
        class="form__button"
        :isDisabled="!isFormValid"
        :isLoading="isLoading"
    >
      {{ t('buttons.reset') }}
      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
        <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="#3b3b3b" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </ui-button>
  </form>
</template>

<script setup>
import {isPasswordValid} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";
import {computed, ref} from "vue";
import {ElNotification} from "element-plus";
import {Auth} from "@/core/api/auth.js";
import {useI18n} from "vue-i18n";
import UiButton from "@/components/ui/ui-button.vue";
import {useRoute, useRouter} from "vue-router";

const {t} = useI18n()
const route = useRoute()
const router = useRouter()

const uid = computed(() => {
  return route.query.uid ? route.query.uid : ''
})
const token = computed(() => {
  return route.query.token ? route.query.token : ''
})

const password = ref('')
const passwordConfirm = ref('')

const isLoading = ref(false)

const compareStrings = (v) => {
  if (v === password.value) return true
  return t('errors.compare')
}

const isFormValid = computed(() => {
  return (
      isPasswordValid(password.value) === true &&
      compareStrings(passwordConfirm.value) === true
  )
})

const confirmResetPassword = async () => {
  isLoading.value = true

  const res = await Auth.confirmResetPassword(uid.value, token.value, password.value, passwordConfirm.value)

  if (!res.errors) {
    await router.push({
      name: 'login',
      params: {
        locale: localStorage.getItem('digitgiftcode-user-locale') || 'en-gb'
      }
    })

    ElNotification({
      message: t('popup.successNewPassword'),
      type: 'success'
    })
  } else {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }

  isLoading.value = false
}
</script>

<style lang="scss" scoped>
.form {
  width: 400px;
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 15px;

  &__text {
    color: #000000;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: -0.16px;

    & a {
      transition: 0.2s;
      color: #DD6196;
      font-weight: 600;
      line-height: 27px;
      letter-spacing: -0.16px;
      text-decoration: underline;

      @include hover {
        color: #ec247c;
      }
    }
  }

  &__link {
    transition: 0.2s;
    color: #DD6196;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: -0.16px;
    text-decoration: underline;

    @include hover {
      color: #ec247c;
    }
  }

  &__button {
    width: fit-content;
    padding-inline: 20px;
    align-self: flex-end;
  }
}

@media (max-width: 600px) {
  .form {
    width: 100%;
  }
}
</style>